import {Component, OnInit} from '@angular/core';
import {map, Observable} from "rxjs";
import {ColDef, RowClickedEvent} from "ag-grid-community";
import {AuditingService} from "../../../services/auditing.service";
import {AuditEventTables} from "../../../table-definitions/audit-event-tables";
import {IFailedAuditEvent} from "../../../interfaces/audit/IFailedAuditEvent";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {AuditTablesBase} from "../audit-tables-base";
import {DateService} from "../../../services/date.service";
import {FailedAuditDetailComponent} from "../../dialogs/failed-audit-detail/failed-audit-detail.component";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {MatDialog} from "@angular/material/dialog";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {MatFormField, MatFormFieldModule, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatButton} from "@angular/material/button";
import {AgGridAngular} from "ag-grid-angular";
import {AsyncPipe, NgClass} from "@angular/common";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-failed-audits-table',
  standalone: true,
  templateUrl: './failed-audits-table.component.html',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatSelect,
    MatHint,
    MatOption,
    MatLabel,
    MatDatepickerModule,
    MatFormFieldModule,
    MatButton,
    AgGridAngular,
    AsyncPipe,
    MatIcon,
    NgClass
  ],
  styleUrls: ['./failed-audits-table.component.css']
})
export class FailedAuditsTableComponent extends AuditTablesBase implements OnInit {

  public failedAudits$: Observable<IFailedAuditEvent[]> = this.auditingService.failedAudits$.pipe(map((responseP) => {
    this.pagedAuditResponse = responseP;
    return responseP.Data;
  }));
  public failedAuditColDefs: ColDef[] = this.auditEventTables.failedAuditEventColDefs;
  public sourceTypeFormControl: FormControl = new FormControl('');
  public failedAuditFilterFormGroup = new FormGroup(
    {
      sourceTypeId: this.sourceTypeFormControl,
      eventTypeValue: this.eventTypeFormControl,
      fromDate: this.fromDateFormControl,
      toDate: this.toDateFormControl,
      genericContentSearch: this.genericContentSearchFormControl
    }
  );

  public sourceTypes = [
    {value: '', label: 'All Sources'},
    {value: 2, label: 'Admin'},
    {value: 1, label: 'Player'},
    {value: 3, label: 'System'}
  ];

  constructor(auditingService: AuditingService,
              dateService: DateService,
              matDialog: MatDialog,
              errorHandlingService: ErrorHandlingService,
              auditEventTables: AuditEventTables) {
    super(auditingService, dateService, matDialog, errorHandlingService, auditEventTables);
  }

  ngOnInit() {
    this.auditingService.retrieveFailedAudits({
      fromDate: this.dateService.twoWeeksAgo(),
      toDate: this.dateService.tomorrow(),
      pageSize: 50,
      pageNumber: 1
    }).subscribe({
        next: () => {
          this.uiState = UIStateEnum.ShowData
        },
        error: (err) => {
          this.errorHandlingService.displayPageLevelErrorMessage(err);
        }
      }
    )
  }

  onRowSelected(failedAuditP: RowClickedEvent<IFailedAuditEvent>) {
    this.matDialog.open(FailedAuditDetailComponent, {
      data: {
        audit: failedAuditP.data
      },
      width: '800px'
    })
  }

  override onResetClick() {
    super.onResetClick();
    this.sourceTypeFormControl.setValue('');
    this.getPaginatedResponse(1);
  }

  getPaginatedResponse(pageNumberP: number): void {
    this.auditingService.retrieveFailedAudits({
      fromDate: new Date(this.fromDateFormControl.value),
      toDate: new Date(this.toDateFormControl.value),
      pageNumber: pageNumberP,
      pageSize: 50,
      eventTypeValue: this.eventTypeFormControl.value,
      sourceTypeId: this.sourceTypeFormControl.value || null,
      genericContentSearch: this.genericContentSearchFormControl.value
    }).subscribe({
      next: () => {
        this.updatePaginator();
      },
      error: (err) => {
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }
}
